export default "__VITE_ASSET__BbkKeAoc__"